"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutContext = void 0;
var CheckoutContext;
(function (CheckoutContext) {
    CheckoutContext["ONBOARDING"] = "onboarding";
    CheckoutContext["TEAM_UPDATE"] = "team_update";
    CheckoutContext["SUBSCRIPTION_MANAGE"] = "subscription_manage";
    CheckoutContext["PORTAL"] = "portal";
})(CheckoutContext || (exports.CheckoutContext = CheckoutContext = {}));
